/**************************************
 *
 * 店舗情報は下記を更新してください。
 -------------------------------------- 
 * 店舗名 / 得意先コード / 配送先コード
 *
 **************************************/
var STORE_CODE_ARRAY = [
  ["sov",16504],
  ["ビストロHENDRY",16545],
  ["ピアンタ板橋",16553],
  ["ピアンタ仲宿",16554],
  ["ピアンタ志村坂上",16555],
  ["ピアンタ中野南口店",16556],
  ["ピアンタ十条",16557],
  ["シブヤバル209",16569],
  ["呑ん処　二〇九",16568]
];


function isPC(){
  return $(window).width() > 749;
}

$(function(){

  //headerロゴの処理
  //processingHeaderLogo();

  //header下にスクロールで非表示、上にスクロールで表示
  headerScrollHideDisplay();
  
  //キーワード検索対象の切り替え
  //switchingKeywordSearchTargets();
  
  // プルダウン数量ボックスの初期値設定
  cartItemQuantityboxPulldown();

  //店舗受け取りの制御
  controllDeliveryStore();
  
  //ブログ一覧ページ
  if( $( '.template-blog' ).length ){
    //ブログ一覧のアコーディオン
    accordionBlogList();
  }

  //商品ページ　ページトップへ
  productPageTopLink();

  //ページ上部のマージン調整
  adjustmentMarginHeader();

});

$( window ).on( 'load', function(){
  
  //Buyee広告タグによるページ上部のマージン調整
  adjustmentMarginTopBuyeeAdTags();
  
  //タブ切り替え
  switchingTab();

});

/*
 * タブ切り替え
 */
function switchingTab(){

  var tabBtn = ".js-tab-btn-wrap";// タブ切り替えボタンのclass
  var tabCon = ".js-tab-contents";// タブコンテンツのclass
  var activeClass= "active";//表示フラグのclass
  var fadeSpd = 200;// フェードの速度

  // 表示フラグのclassがない場合
  if( $( tabBtn+' .'+activeClass ).length == 0 ){
    // 一番最初のタブを表示
    $( tabBtn + ' > li:first-child' ).addClass( activeClass );
  }

  // タブの数だけ処理
  $( "ul" + tabBtn ).each( function(){

    // クリックされたタブのインデックスを取得
    var firstIndex = $( this ).children( "."+activeClass ).index();

    // コンテンツを表示
    $( this ).siblings( tabCon ).css( "position", "relative" );
    $( tabCon ).children( "li" ).css({
      "display":"none",
       "position":"absolute",
       "top":0,
       "left":0
    });

    // 最初のliだけ↑で付加したcssを取る。
    $( tabCon + " > li:first-child" ).css({
      "display":"",
      "position":""
    });

    // activeがついているボタンに対応するtabCon liのdisplay、positionのクラスを取る。
    $( this ).siblings( tabCon ).children( "li" ).eq( firstIndex ).css({
      "display":"",
      "position":""
    });
    
  });

  // ボタンをクリックしたときの処理
  $( "ul"+tabBtn+" li" ).click( function(){

    // クリックしたボタンが何番目か。
    var index = $( this ).parent( "ul" ).children( "li" ).index( this );

    // 他のliについているactiveクラスを取る。

    $( this ).siblings( "li" ).removeClass( activeClass );

    // activeを付ける。
    $( this ).addClass( activeClass );

    // tabConのliにabsoluteを付加し、フェードアウトする。
    $( this ).parent( "ul" ).siblings( tabCon ).children( "li" ).css( "position","absolute" ).fadeOut( fadeSpd );

    // tabConのliにクリックしたボタンのコンテンツのpositionを取ってフェードインする。
    $( this ).parent( "ul" ).siblings( tabCon ).children( "li" ).eq( index ).css( "position","" ).stop().fadeIn( fadeSpd );
  });

}

/*
 * headerロゴの処理
 */
//function processingHeaderLogo(){
  
//  var scrollClass = 'js-scroll';
  
//  //ページ読み込み時
//  if( $( window ).scrollTop() > 10 ){
//    //スクロール位置が最上部以外の場合、headerにクラスを付与
//    $( 'header' ).addClass( scrollClass );
//  }else{
//    $( 'header' ).removeClass( scrollClass );
//  }
  
//  //スクロール時
//  $( window ).on( 'scroll',function(){
    
//    //スクロール位置が最上部以外の場合、headerにクラスを付与
//    if( $( this ).scrollTop() > 10 ){
//      $( 'header' ).addClass( scrollClass );
//    }else{
//      $( 'header' ).removeClass( scrollClass );
//    }
    
//  });
//}

/*
 * header下にスクロールで非表示、上にスクロールで表示
 */
function headerScrollHideDisplay(){
  var pos = 0;
  var header = $('#shopify-section-header');
  
  $(window).on('scroll', function(){
    if($(this).scrollTop() < pos || $(this).scrollTop() < 300){
      //上にスクロールしたとき
      header.slideDown();
    }else{
      //下にスクロールしたとき
      header.slideUp();
    }
    //スクロールが停止した位置を保持
    pos = $(this).scrollTop();
  });
}

/*
 * キーワード検索対象の切り替え
 */
function switchingKeywordSearchTargets(){
  
  $( '.search-bar__form input[name="search-target"]' ).on( 'change',function(){
    
    //「商品を検索する」を選択時、
    if( $( this ).val() == 'product' ){
      //検索対象を「商品」に変更
      $( '.search-bar__form input[name="type"]' ).val( 'product' );
      
    //「記事を検索する」を選択時、
    }else {
      //検索対象を「記事」に変更
      $( '.search-bar__form input[name="type"]' ).val( 'article' );
    };
  });
}

/****************************************************************************
* プルダウン数量ボックスの初期値設定
****************************************************************************/
function cartItemQuantityboxPulldown(){
  // カートページ内の数量ボックスが存在するとき
  if($(".cart__qty-input").length){
    var amount;
    // 数量ボックスの数だけ処理
    $("select.cart__qty-input").each(function(){
      // 商品ごとに数量を取得
      amount = $(this).attr("value");
      // 該当の数量を初期値に設定
      $(this).find("option[value='"+ amount +"']").attr("selected","selected");
    });
  }
}

/****************************************************************************
* 店舗受け取りの制御
****************************************************************************/
function controllDeliveryStore(){
  
  var customerCodeName = "customer_code";
  var cookieMaxAge = 60*60*24*365*2;// Cookie保持期間：2年
  var cookieKey = "CUSTOMER_CODE";// Cookie名
  
  //得意先コードをクッキーに保存
  saveCustomerCodeCcookie(customerCodeName,cookieMaxAge,cookieKey);
  
  // カートページ
  if(location.pathname.toString().indexOf("cart") != -1){
    
    //得意先コードに紐づく店舗名・配送先コードを取得
    var storeItems = getStoreNameDeliveryAddressCode(cookieKey);

    //店舗受け取りのプルダウンのデフォルトの値に店舗名を設定
    setStoreNameDefaultValue(storeItems);

  }
  
}


/****************************************************************************
* 得意先コードをクッキーに保存
****************************************************************************/
function saveCustomerCodeCcookie(customerCodeName,cookieMaxAge,cookieKey){
  
  //URL例）https://www.sake-ya.jp/?customer_code=13927
  
  //パラメータを取得
  var param = location.search;
  
  //パラメータに得意先コードがなければ処理終了
  if(param.indexOf(customerCodeName) == -1){
    //console.log('パラメータなしor得意先コードなし');
    return false;
  }
  
  //得意先コードを取得
  var regexp = new RegExp(customerCodeName+'='+ '([0-9]+)');
  var cookieValue = param.match(regexp);
  if(cookieValue) cookieValue = cookieValue[1];
  
  //得意先コードをクッキーに保存
  document.cookie = cookieKey+"="+cookieValue+";max-age="+cookieMaxAge+";path=/";
  //console.log("save cookie:"+cookieKey+"="+cookieValue+";max-age="+cookieMaxAge);

}


/****************************************************************************
* 得意先コードに紐づく店舗名・配送先コードを取得
****************************************************************************/
function getStoreNameDeliveryAddressCode(customerCodeCookieKey){
  
  var cookies = document.cookie;// 全てのcookieを取得
  var cookiesArray = cookies.split(';');// 配列に格納
  var savedCookie, savedCookieKey;
  var customerCodeValue = "";//得意先コード
  var storeName, shippingCode;
  
  //得意先コードがクッキーに保存されているかどうかを判定
  for(var i=0; i<cookiesArray.length; i++){
    savedCookie = cookiesArray[i].split('=');
    savedCookieKey = savedCookie[0].trim();
    // 得意先コードがクッキーに保存されていれば
    if( savedCookieKey == customerCodeCookieKey){ 
      //得意先コードを取得
      customerCodeValue = savedCookie[1];
      //ループ終了
      break;
    }
  }
  
  //得意先コードがクッキーに保存されていなければ、処理終了
  if(!customerCodeValue){
    //console.log('得意先コードがクッキーにない');
    return false;
  }
  
  
  //得意先コードに紐づく店舗名、配送先コードを取得
  for(var i=0; i<STORE_CODE_ARRAY.length; i++){
    
    //店舗情報の多次元配列からマッチするものを取得
    if(customerCodeValue == STORE_CODE_ARRAY[i][1]){
      
      //店舗名
      storeName = STORE_CODE_ARRAY[i][0];
      
      break;
    }
  }
  
  //店舗情報を配列に格納
  var storeItems = [storeName,customerCodeValue];
  
  return storeItems;


}


/****************************************************************************
* 店舗受け取りのプルダウンのデフォルトの値に店舗名を設定
****************************************************************************/
function setStoreNameDefaultValue(storeItems){
  var referralStoreCode;//紹介店コード
  var storeCodeValue;
  
  //クッキーあり・なしの紹介店コードをセット
  if( !storeItems ){
    referralStoreCode = '';
  }else{
    referralStoreCode = storeItems[1];
  }
    
  //console.log( referralStoreCode );
  
  //optionタグに店舗名を追加
  for(var i=0; i<STORE_CODE_ARRAY.length; i++){
    $('#deliveryDestination').append('<option>'+STORE_CODE_ARRAY[i][0]+'</option>');
  }
  
  //受け取り先を変更したら
  $(document).on("change", '#deliveryDestination', function () {
    
    if( $(this).val() == 'ご自宅' ){
      //メタフィールドの値を削除
      $( '.cart-attibutes__storecode' ).val( referralStoreCode+':受取店コード:' );
      
    }else{
      for(var i=0; i<STORE_CODE_ARRAY.length; i++){

        if( STORE_CODE_ARRAY[i].indexOf($(this).val()) != -1 ){
    //メタフィールドに「得意先：店舗名」を再セット
          $( '.cart-attibutes__storecode' ).val( referralStoreCode+':受取店コード:'+STORE_CODE_ARRAY[i][1] );
    
          break;
        }
      }
    }
    
    //メタフィールドの値を1つにまとめる処理
    storeCodeValue = $( '.cart-attibutes__storecode' ).val();
    mainCombineMetafieldValuesIntoOne( storeCodeValue );
    
  });
  
  //クッキーに得意先コードがなかったら
  if(!storeItems){
    
    //メタフィールドに紹介店コード（なし）、受取店（デフォルト値）をセット
    $( '.cart-attibutes__storecode' ).val( referralStoreCode+':受取店コード:' );
    
    //処理終了
    return false;
  }
    
  //受け取り先のデフォルト値にクッキーの値を設定
  $('#deliveryDestination').val(storeItems[0]);
  
  //メタフィールドに紹介店・受取店コード（クッキーの値）をセット
  //$( '.cart-attibutes__storecode' ).val( referralStoreCode+':受取店コード:'+referralStoreCode );
  $( '.cart-attibutes__storecode' ).val( referralStoreCode+':受取店コード:' );//WEB_0001-8014変更
  
}


/****************************************************************************
* 【店舗先】の選択肢を表示の制御
***************************************************************************
function controllDisplayStoreSelect(){
  
  var thisSelectDelivery;
  
  //受け取り先の値を変更したら
  $(document).on("change", '#deliveryDestination', function () {
    //メイン処理
    thisSelectDelivery = this;
    controllDisplayStoreSelectMain(thisSelectDelivery);
  });
    //メイン処理
    controllDisplayStoreSelectMain();
}*/


/****************************************************************************
* 【店舗先】の選択肢を表示の制御(メイン処理)
***************************************************************************
function controllDisplayStoreSelectMain(thisSelectDelivery){
  
  var storeValue = '店舗';//受け取り先が店舗の場合のselect値
  
  //受け取り先が「店舗」の場合
  if($(thisSelectDelivery).val() == storeValue){
    //選択肢「店舗先」を表示
    $('.cart-delivery__store').addClass('visible');
  }else{
    //選択肢「店舗先」を表示
    $('.cart-delivery__store').removeClass('visible');
  }


}*/

/****************************************************************************
* メタフィールドの値を1つにまとめる処理
* 呼び出し元：deliveryDate.js(56行目)
****************************************************************************/
function combineMetafieldValuesIntoOne(){

  //紹介店・受取店コードの値を取得
  var storeCodeValue = $( '.cart-attibutes__storecode' ).val();
  mainCombineMetafieldValuesIntoOne( storeCodeValue );
  
  //受け取り先、配送希望日・時間帯を変更したとき
  $( document ).on( 'change', '#deliveryDate, #deliveryTime', function(){

    mainCombineMetafieldValuesIntoOne( storeCodeValue );
    
  } );
}

//メタフィールドの値を1つにまとめる（メイン処理）
function mainCombineMetafieldValuesIntoOne( storeCodeValue ){

  //配送希望日
  var deliveryDateValue = $( '#deliveryDate' ).val();
  
  //配送時間帯
  var deliveryTimeValue = $( '#deliveryTime' ).val();
  
  //例  紹介店コード:16786:受取店コード:     :配送希望日: 2021-05-06:配送時間帯: 12時～14時
  var combineValue = storeCodeValue+':配送希望日: '+deliveryDateValue+':配送時間帯: '+deliveryTimeValue;
  
  //値をメタフィールドにセット
  $( '.cart-attibutes__storecode' ).val( combineValue );
  
  //console.log( $( '.cart-attibutes__storecode' ).val() );
  
}

/****************************************************************************
* ブログ一覧のアコーディオン
****************************************************************************/
function accordionBlogList(){
  if( $( '.js-blog-accordion' ).length ){
    //ボタンをクリックしたら
    $('.js-blog-accordion').on('click', function () {
      //その次の要素をスライドトグル
      $(this).next().slideToggle(200);
      //矢印の向きを変更
      $(this).toggleClass('open', 200);
    });
  }
}

jQuery(function ($) {
  // slick 2週目のカクつき対応
  const $slider = $("#shopify-section-162797174904ae4238 .slick-slider");

  $slider.on("beforeChange", (event, slick, currentSlide, nextSlide) => {
    $slider.find(".slideshow__slide").each((index, el) => {
      const $this = $(el),
      slickindex = $this.attr("data-slick-index");
      if (nextSlide == slick.slideCount - 1 && currentSlide == 0) {
        if (slickindex == "-1") {
          $this.addClass("is-active-next");
        } else {
          $this.removeClass("is-active-next");
        }
      } else if (nextSlide == 0) {
        if (slickindex == slick.slideCount) {
          $this.addClass("is-active-next");
        } else {
          $this.removeClass("is-active-next");
        }
      } else {
        $this.removeClass("is-active-next");
      }
    });
  });
});

/****************************************************************************
* Buyee広告タグによるページ上部のマージン調整
****************************************************************************/
function adjustmentMarginTopBuyeeAdTags(){
  var bannerIdTop = '#for_sake-ya4848-to-page';//トップページのバナーID
  var bannerIdProduct = '#for_sake-ya4848-to-item';//商品ページのバナーID
  var headerHeight = $( '#shopify-section-header' ).height();//ヘッダーの高さを取得
  
  //バナーが表示されたと場合
  if( $( bannerIdTop ).css( 'display' ) ==  'block' || $( bannerIdProduct ).css( 'display' ) ==  'block' ){
    //広告でコンテンツの上部が隠れてしまうのを防ぐため上部にマージンを付与
    if( $( '.template-index' ).length ){
      //トップページ
      $( '.main-content' ).css( 'padding-top', headerHeight );
    }else if( $( '.template-product' ).length ){
      //商品ページ
      $( '.page-container' ).css( 'margin-top', headerHeight );
    }
  }
}

/****************************************************************************
* ページ上部のマージン調整
****************************************************************************/
function adjustmentMarginHeader(){
  var headerHeight = $( '#shopify-section-header' ).height();//ヘッダーの高さを取得
  
    //広告がない場合
    if( $( '.template-index' ).length ){
      //トップページ
      $( '.main-content' ).css( 'padding-top', headerHeight );
    }else {
      //その他ページ
      $( '.page-container' ).css( 'margin-top', headerHeight );
    }
}

/****************************************************************************
* 商品詳細　ページトップへ
****************************************************************************/
function productPageTopLink(){
  if( $( '.template-product' ).length ){
    if($('#product_page_top').length){
      // 100px スクロールしたらボタン表示
      $(window).scroll(function(){
        if($(this).scrollTop() > 100){
          $('#product_page_top').fadeIn();
        } else{
          $('#product_page_top').fadeOut();
        }
      });
      $('#product_page_top').click(function(){
        $('body, html').animate({scrollTop:0},500);
        return false;
      });
    }
  }
}
